// Pain subsection form field enum
export enum PainFormField {
  PAIN_STATUS = 'medical-background/pain/status',
  PAIN_GOAL = 'medical-background/pain/goal',
  PAIN_FLACC_SCALE_FACE = 'medical-background/pain/flacc-scale-face',
  PAIN_FLACC_SCALE_LEGS = 'medical-background/pain/flacc-scale-legs',
  PAIN_FLACC_SCALE_ACTIVITY = 'medical-background/pain/flacc-scale-activity',
  PAIN_FLACC_SCALE_CRY = 'medical-background/pain/flacc-scale-cry',
  PAIN_FLACC_SCALE_CONSOLABILITY = 'medical-background/pain/flacc-scale-consolability',
  PAIN_SYSTEM_SUMMARY = 'medical-background/pain/system-summary'
}
